import { Image } from '@cian/ui-kit/image';
import { ArticleHeading3, Body1, Body2, Caption } from '@cian/ui-kit/typography';

import { NoPhoto } from 'shared/components/common/NoPhoto';
import type { ISimilarBuildingView } from 'shared/utils/similarBuildings';

import style from './style.css';

export interface ISimilarBuildingsProps {
  title: string;
  buildings: ISimilarBuildingView[];
}

const SimilarBuildingCard = ({ building }: { building: ISimilarBuildingView }) => {
  const { url, photoUrl, name, buildingTypeLabel, classLabel, underground, address, representativeName } = building;

  return (
    // Как `OfferCard` монолита: карточка целиком — ссылка в новой вкладке
    <a href={url ?? undefined} target="_blank" rel="noopener" className={style['card']} data-name="SimilarBuilding">
      <div className={style['photo']}>
        {photoUrl ? (
          <Image src={photoUrl} alt="" objectFit="cover" width="100%" height="100%" borderRadius={0} />
        ) : (
          <NoPhoto variant="similar" />
        )}
      </div>
      <div className={style['text']}>
        <h3 className={style['heading']}>
          <Body1 as="span" fontWeight="bold">
            {[buildingTypeLabel, name].filter(Boolean).join(' ')}
          </Body1>
          {classLabel && (
            <span className={style['class']}>
              <Caption as="span" color="text-secondary-default">
                {classLabel}
              </Caption>
            </span>
          )}
        </h3>
        {address && <Body2 color="text-secondary-default">{address}</Body2>}
        {underground && (
          <div className={style['metro']}>
            <div className={style['metro-name']}>
              {underground.color && <span className={style['metro-icon']} style={{ background: underground.color }} />}
              <Body2>{underground.name}</Body2>
            </div>
            {underground.timeText && <Body2 color="text-secondary-default">{underground.timeText}</Body2>}
          </div>
        )}
      </div>
      {representativeName && (
        <div className={style['representative']}>
          <Caption color="text-secondary-default">{representativeName}</Caption>
        </div>
      )}
    </a>
  );
};

/** Блок «Похожие» внизу страницы — `offer_card_list.tsx` монолита без AdFox-карточки */
export const SimilarBuildings = ({ title, buildings }: ISimilarBuildingsProps) => (
  <section className={style['section']} data-name="SimilarBuildings">
    <div className={style['container']}>
      <ArticleHeading3 as="h2">{title}</ArticleHeading3>
      <div className={style['list']}>
        {buildings.map(building => (
          <SimilarBuildingCard key={building.id} building={building} />
        ))}
      </div>
    </div>
  </section>
);
